export default function IframeTester() {
  return (
    <iframe
      title="backpain.today.survey"
      src="https://backpain.today/survey-iframe?partner=SAA"
      width="100%"
      height="1500px"
      style={{
        height: "calc(100vh - 15px) !important",
        border: "0 !important",
      }}
    />
  );
}
